<template>
  <!-- Main content -->
  <div class="main-content" id="panel">
    <!-- Topnav -->
    <!-- <Header /> -->
    <!-- Header -->
    <!-- Header -->
    <div class="header bg-primary pb-6">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row align-items-center py-4">
            <div class="col-lg-6 col-7">
              <h2>Purposes</h2>
              <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
                <ol class="breadcrumb breadcrumb-links breadcrumb-dark">
                  <li class="breadcrumb-item">
                    <i class="fas fa-home"></i>
                  </li>
                  <li class="breadcrumb-item">Site Administration</li>
                  <li class="breadcrumb-item active" aria-current="page">Manage Purposes</li>
                </ol>
              </nav>
            </div>
          </div>
          <!-- Card stats -->
        </div>
      </div>
    </div>
    <div class="container-fluid mt--6">
      <div class="row xsOnly">
        <div class="col-xl-8">
          <div class="card scrollbar" id="scroll">
            <div class="card-header bg-transparent">
              <div class="row align-items-center">
                <div class="col">
                  <h3>Purposes</h3>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <div v-if="loading" class="loader"><img src="../../assets/img/loader.svg" alt=""/></div>
              <table class="table align-items-center table-flush table-hover">
                <thead class="thead-light psticky">
                  <tr>
                    <th scope="col" class="sort">Purpose</th>
                    <th scope="col" class="sort text-center">Action</th>
                  </tr>
                </thead>
                <tbody class="list">
                  <tr v-for="purpose in purposes" :key="purpose.id">
                    <td>{{purpose.purpose}}</td>
                    <td>
                      <a
                        href="#"
                        @click="deletePurposeId = purpose.id"
                        data-toggle="modal"
                        data-target="#deletePurposeModal"
                      >
                        <span class="btn-icon">
                          <i class="far fa-trash-alt"></i>
                        </span>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- Pagination-->
              <b-pagination
                class="mt-4"
                :total-rows="totalRows"
                v-model="currentPage"
                :per-page="perPage"
                @input="getPurposeList(currentPage)"
              ></b-pagination>
              <div class="total-records">
                <span>Total Records : {{totalRows}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-4">
          <div class="card">
            <div class="card-header bg-transparent">
              <div class="row align-items-center">
                <div class="col">
                  <h3>Add New Purpose</h3>
                </div>
              </div>
            </div>
            <div class="card-body">
              <!-- Chart -->
              <div class="chart addPurpose">
                <div class="form-group">
                  <div class="input-group input-group-merge input-group-alternative">
                    <input
                      class="form-control"
                      placeholder="Enter Purpose"
                      type="text"
                      v-model="newPurposeName"
                    />
                  </div>
                  <button type="button" class="btn btn-primary" @click="addPurPose()">
                    ADD
                    <i class="fas fa-plus-circle"></i>
                  </button>
                </div>
                <br />
                <div class="alert alert-success" role="alert" v-if="purposeAdded">
                  <i class="fas fa-check-circle"></i>
                  New purpose successfully added
                </div>
                <div class="alert alert-danger" role="alert" v-if="error">{{error}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Footer -->
      <!-- <Footer /> -->
      <div
        class="modal fade"
        id="deletePurposeModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Confirm</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <i class="fas fa-exclamation-triangle"></i>
              <p>Are you sure you want to delete this data?</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-danger" @click="deletePurposeData()">Delete</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-unused-vars */
// import Header from "../common/Header";
// import Footer from "../common/Footer";
import config from "@/config";
//import this.$http from "this.$http";
//import $ from "jquery";

export default {
  name: "PurposePage",
  components: {
    // Header,
    // Footer
  },
  data() {
    return {
      accessToken: null,
      purposes: [],
      loading: false,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      deletePurposeId: null,
      newPurposeName: "",
      purposeAdded: false,
      editMode: false,
      error: null
    };
  },
  methods: {
    getPurposeList(currentPage) {
      this.loading = true;
      if (!currentPage) {
        currentPage = 1;
      }
      const auth = { headers: { authorization: this.accessToken } };
      this.$http
        .get(
          config.baseUrl +
            "/purpose/list?startAt=" +
            (currentPage * 10 - 10) +
            "&perPage=" +
            this.perPage,
          auth
        )
        .then(result => {
          this.totalRows = result.data.count;
          this.purposes = result.data.data;
          this.loading = false;
        });
    },
    deletePurposeData() {
      const auth = { headers: { authorization: this.accessToken } };
      this.$http
        .delete(config.baseUrl + "/purpose/" + this.deletePurposeId, auth)
        .then(result => {
          console.log(result);
          this.getPurposeList(this.currentPage);
          window.$("#deletePurposeModal").modal("hide");
        });
    },
    addPurPose() {
      this.error = false;
      if (!this.newPurposeName) {
        this.error = "Purpose name is required";
        return false;
      }
      const auth = {
        headers: { authorization: this.accessToken }
      };
      this.$http
        .post(
          config.baseUrl + "/purpose",
          {
            purpose: this.newPurposeName
          },
          auth
        )
        .then(response => {
          this.purposeAdded = true;
          this.error = false;
          this.newPurposeName = "";
          this.getPurposeList();
        })
        .catch(e => {
         this.error = e.response.data;
        });
    }
  },
  mounted(currentPage) {
    this.$cognitoAuth.getIdToken((err, result) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        this.accessToken = result;
        this.getPurposeList(currentPage);
      }
    });
  }
};
</script>